import React from 'react';
import { createIcon } from '../../../utils/createIcon';

const IconLineDashed = createIcon({
  viewBox: '0 0 312 8',
  path: (
    <g
      fill="none"
      fillRule="evenodd"
      strokeDasharray="10 10"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <g strokeWidth="6">
        <g>
          <g>
            <path
              stroke="#B7CEEC"
              d="M2.229 4L104.743 4"
              transform="translate(-24 -84) translate(24 32) translate(0 52)"
            />
            <path
              stroke="#618ACC"
              d="M104.743 4L207.257 4"
              transform="translate(-24 -84) translate(24 32) translate(0 52)"
            />
            <path
              stroke="#2E55A5"
              d="M207.257 4L309.771 4"
              transform="translate(-24 -84) translate(24 32) translate(0 52)"
            />
          </g>
        </g>
      </g>
    </g>
  ),
});

export default IconLineDashed;
